module.exports = __webpack_public_path__ + "static/media/logo-text.4263477e.svg";